import { Box, IconButton, Typography } from "@mui/material";
import GridOnIcon from "@mui/icons-material/GridOn";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import React from "react";
import { Export4PLExportPartner } from "../analyzeSlice";
import { useSelector, useDispatch } from "react-redux";
import MultiSelectColumns from "./MultiSelectColumns";

export default function ExportFourPLData() {
	const dispatch = useDispatch();
	const state = useSelector((store) => store.analyze);
	
	const { fourPLDataPrepared, 
			selectedColumns,
			selectedCountryID,
			selectedCountry,
			duration,
		} = state;
	const { rows, columns } = fourPLDataPrepared;

	console.log(rows, selectedColumns);

	function exportDataAsFile(isPdf) {

		const filteredArray = rows.map(obj => {
			const filteredObj = {};
			selectedColumns.forEach(key => {
			  if (obj.hasOwnProperty(key)) {
				filteredObj[key] = obj[key];
			  }
			});
			return filteredObj;
		  });

		  console.log(filteredArray)

		const obj = {
			AnalyzeTitle: "Analyze: 4PL Export Partner",
			CountryID: selectedCountryID,
			CountryName: selectedCountry,
			period: duration,
			listAnalyze4PLTableData: filteredArray
		};
		dispatch(Export4PLExportPartner(obj));
	}

	return (
		<Box
			sx={{
				mt: 3,
				display: "flex",
				flexDirection: "row",
				justifyContent: "flex-start",
			}}
		>
			<Typography variant="subtitle1" sx={{ color: "blue.main", mt: 1, mr: 2,}}>
				Analyze 3 PL Data
			</Typography>

			<Box
				sx={{
					display: "flex",
					flexDirection: "row",
					justifyContent: "flex-start",
				}}
			>
				<MultiSelectColumns columns={columns}/>
			</Box>

			<Box
				sx={{
					display: "flex",
					flexDirection: "row",
					justifyContent: "flex-end",
					ml: "calc(100% - 550px)",
				}}
			>
				<IconButton onClick={(e) => exportDataAsFile(false)}>
					<GridOnIcon sx={{ color: "green.main" }} />
				</IconButton>
				{/* <IconButton onClick={(e) => exportDataAsFile(true)}>
					<PictureAsPdfIcon sx={{ color: "red.main" }} />
				</IconButton> */}
			</Box>
		</Box>
	);
}
